import { Dialog, DialogContent, Box, Typography, Divider, TextField, DialogActions } from '@mui/material';
import { User } from '../type';
import { CloseButton } from './CloseButton';
import { CancelButton } from './CancelButton';
import { formatDate } from '../utils/dateUtils';

interface UserDetailDialogProps {
  user: User | null;
  onClose: () => void;
}

export const UserDetailDialog = ({ user, onClose }: UserDetailDialogProps) => {
  return (
    <Dialog
      open={!!user}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      {/* 상단 닫기 버튼 및 제목 */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 3, pt: 3, pb: 2 }}>
        <Typography variant="h6" sx={{ fontSize: '1.25rem' }}>
          유저 상세 정보
        </Typography>
        <CloseButton onClose={onClose} />
      </Box>
      <Divider />
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0.5 }}>
          {user && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                label="사용자 ID"
                value={user.uid}
                slotProps={{ input: { readOnly: true } }}
                fullWidth
              />
              <TextField
                label="이메일"
                value={user.email}
                slotProps={{ input: { readOnly: true } }}
                fullWidth
              />
              <TextField
                label="이름"
                value={user.displayName}
                slotProps={{ input: { readOnly: true } }}
                fullWidth
              />
              <TextField
                label="전화번호"
                value={user.phoneNumber}
                slotProps={{ input: { readOnly: true } }}
                fullWidth
              />
              <TextField
                label="기업 사용자 여부"
                value={user.isEnterpriseUser ? 'O' : 'X'}
                slotProps={{ input: { readOnly: true } }}
                fullWidth
              />
              {user.isEnterpriseUser && (
                <TextField
                  label="기업 ID"
                  value={user.enterpriseId || '설정되지 않음'}
                  slotProps={{ input: { readOnly: true } }}
                  fullWidth
                />
              )}
              <TextField
                label="필수 약관 동의"
                value={user.termsAgreed.required ? 'O' : 'X'}
                slotProps={{ input: { readOnly: true } }}
                fullWidth
              />
              <TextField
                label="선택 약관 동의"
                value={user.termsAgreed.optional ? 'O' : 'X'}
                slotProps={{ input: { readOnly: true } }}
                fullWidth
              />
              <TextField
                label="가입일"
                value={formatDate(user.createdAt)}
                slotProps={{ input: { readOnly: true } }}
                fullWidth
              />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <CancelButton onClick={onClose}>닫기</CancelButton>
      </DialogActions>
    </Dialog>
  );
};
